import React, { useState } from "react";
import { useKycStore } from "../../stores/useKycStore";
import Checkbox from "../../components/shared/Checkbox";

export default function PreRainTerms() {
  const [checked1, setChecked1] = useState(false);
  const [checked2, setChecked2] = useState(false);
  const [checked3, setChecked3] = useState(false);
  const { setAcceptedRainTerms } = useKycStore();

  const allChecked = checked1 && checked2 && checked3;

  return (
    <div className="flex flex-col gap-6 w-full pt-4">
      <div className="text-[#CBCED1] font-['Neue Montreal'] text-[18px] font-medium leading-[22.5px]">
        By continuing you accept our terms
      </div>
      <div className="flex flex-col gap-1 w-full">
        <Checkbox
          checked={checked1}
          onChange={setChecked1}
          label={
            <>
              I accept the{" "}
              <a href="#" className="underline">
                BrahmaFi Card Terms Privacy Policy
              </a>
            </>
          }
          className="rounded-t-md"
        />
        <Checkbox
          checked={checked2}
          onChange={setChecked2}
          label="I certify that the information I have provided is accurate and that I will abide by all the rules and requirements related to my BrahmaFi Card"
        />
        <Checkbox
          checked={checked3}
          onChange={setChecked3}
          label={
            <>
              I confirm I&apos;m not a U.S. resident, have reviewed the{" "}
              <a href="#" className="underline">
                supported countries list
              </a>
              , comply with local laws, and understand the BrahmaFi card is not
              an unauthorised solicitation.
            </>
          }
          className="rounded-b-md"
        />
      </div>
      <button
        className={`flex h-[44px] justify-center items-center gap-1 self-stretch rounded-lg bg-white backdrop-blur-[6px] text-black font-medium ${
          !allChecked ? "opacity-50 cursor-not-allowed" : ""
        }`}
        disabled={!allChecked}
        onClick={() => setAcceptedRainTerms(true)}
      >
        Continue
      </button>
    </div>
  );
}
